import type { IconSvgObject } from './types';

const Forward02Icon: IconSvgObject = [
  ["path", { d: "M13.9453 17.8986C13.2826 18.3625 12.3719 17.8884 12.3719 17.0793V6.92065C12.3719 6.11163 13.2826 5.63748 13.9454 6.10142L21.2016 11.1808C21.7703 11.5789 21.7703 12.4211 21.2016 12.8192L13.9453 17.8986Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.94535 17.8986C3.28257 18.3625 2.37189 17.8884 2.37189 17.0793V6.92065C2.37189 6.11163 3.28257 5.63748 3.94535 6.10142L11.2016 11.1808C11.7703 11.5789 11.7703 12.4211 11.2016 12.8192L3.94535 17.8986Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Forward02Icon;
